export default function AppDownloadCTA() {
  return (
    <section id="app-download" className="bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <div className="relative rounded-2xl overflow-hidden mb-10 aspect-[16/9]">
            <img
              src="https://readdy.ai/api/search-image?query=Smartphone%20displaying%20Chinese%20entertainment%20news%20app%20interface%20on%20screen%20modern%20minimalist%20design%20with%20warm%20ambient%20lighting%20editorial%20product%20photography%20elegant%20composition%20with%20soft%20shadows%20dark%20background%20cinematic%20mood&width=1200&height=675&seq=app-mockup-2026&orientation=landscape"
              alt="91在线视频APP界面预览"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
          </div>

          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-3 leading-tight">
            随时随地
          </h2>
          <p className="text-xl md:text-2xl font-heading text-foreground-600 mb-2 italic">
            吃瓜快人一步
          </p>
          <p className="text-base text-foreground-500 mb-8">
            下载91在线视频APP，第一时间获取网红黑料、吃瓜爆料、热门事件追踪
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#"
              className="px-10 py-3.5 rounded-full bg-foreground-950 text-background-50 font-label font-semibold text-sm hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-android-line mr-2"></i>
              Android 下载
            </a>
            <a
              href="#"
              className="px-10 py-3.5 rounded-full bg-foreground-950 text-background-50 font-label font-semibold text-sm hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-apple-line mr-2"></i>
              iOS 下载
            </a>
          </div>

          <p className="text-xs text-foreground-400 mt-6">
            支持 Android 8.0+ / iOS 15.0+ | 版本 v3.2.1 | 安全无毒
          </p>
        </div>
      </div>
    </section>
  );
}